<div
  class="mt-5px js-feed-post-icon-row__container fs-14px text-grey5 d-flex justify-content-between max-width-420px unselectable"
>
  <div
    class="cursor-pointer d-flex align-items-center"
    (click)="openModal($event)"
    data-toggle="modal"
    data-target=".js-feed-post-icon-row__comment-modal"
  >
    <i class="icon-reply feed-post-icon-row__icon"></i>
    <span *ngIf="!hideNumbers">{{ postContent.CommentCount }}</span>
  </div>

  <div
    (click)="$event.stopPropagation()"
    class="btn-group cursor-pointer d-flex align-items-center"
    dropdown
    #dropdown="bs-dropdown"
    [ngClass]="{
      'fc-green': postContent.PostEntryReaderState
        ? postContent.PostEntryReaderState.RepostedByReader
        : false
    }"
  >
    <a
      class="link--unstyled"
      dropdownToggle
      id="repostActionsButton"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <i class="icon-repost feed-post-icon-row__icon"></i>
    </a>
    <div
      class="dropdown-menu p-0 fs-12px border background-color-light-grey"
      style="min-width: 6rem"
      *dropdownMenu
      aria-labelledby="repostActionsButton"
    >
      <a
        *ngIf="sendingRepostRequest; else repostOptions"
        class="dropdown-menu-item d-block p-5px feed-post__dropdown-menu-item"
      >
        <div class="fc-muted">Loading...</div>
      </a>
      <ng-template #repostOptions>
        <a
          *ngIf="userHasReposted(); else repostElseBlock"
          class="dropdown-menu-item d-block link--unstyled p-5px feed-post__dropdown-menu-item"
          (click)="_undoRepost($event)"
        >
          <i class="icon-repost feed-post-icon-row__icon fs-12px"></i>
          Hide
        </a>
        <ng-template #repostElseBlock>
          <a
            class="dropdown-menu-item d-block link--unstyled p-5px feed-post__dropdown-menu-item"
            (click)="_repost($event)"
          >
            <i class="icon-repost feed-post-icon-row__icon fs-12px"></i>
            Repost
          </a>
        </ng-template>
        <a
          class="dropdown-menu-item d-block link--unstyled p-5px feed-post__dropdown-menu-item"
          (click)="openModal($event, true)"
        >
          <i
            class="fas fa-pencil-alt feed-post-icon-row__icon pl-5px"
            style="font-size: 10px"
          ></i>
          Quote
        </a>
      </ng-template>
    </div>
    <span *ngIf="!hideNumbers">{{
      postContent.RepostCount + postContent.QuoteRepostCount
    }}</span>
  </div>

  <div
    (click)="toggleLike($event)"
    [ngClass]="{
      'fc-red': postContent.PostEntryReaderState
        ? postContent.PostEntryReaderState.LikedByReader
        : false
    }"
    class="cursor-pointer d-flex align-items-center"
  >
    <i
      [ngClass]="{
        is_animating: animateLike,
        'icon-heart': postContent.PostEntryReaderState
          ? !postContent.PostEntryReaderState.LikedByReader
          : true,
        'icon-heart-fill': postContent.PostEntryReaderState
          ? postContent.PostEntryReaderState.LikedByReader
          : false
      }"
      (click)="animateLike = !animateLike"
      class="feed-post-icon-row__icon"
    ></i>
    <span *ngIf="!hideNumbers">{{ postContent.LikeCount }}</span>
  </div>

  <ng-template #popTemplate>
    <div id="diamond-popover" class="m-10px">
      <div *ngIf="!sendingDiamonds">
        <div class="mb-4" style="font-size: 11.25px">
          Give a diamond.
          <b>@{{ postContent.ProfileEntryResponse.Username }}</b>
          will receive the amount shown as
          <b>a tip</b>
          from you.
        </div>
      </div>
    </div>
  </ng-template>
  <div class="cursor-pointer d-flex align-items-center">
    <!--Container to hold the bounds for the mobile drag interface-->
    <div
      class="diamond-mobile-drag-container unselectable"
      [ngClass]="{
        'hide-diamonds':
          !globalVars.loggedInUser?.PublicKeyBase58Check ||
          postContent.ProfileEntryResponse?.PublicKeyBase58Check ===
            globalVars.loggedInUser?.PublicKeyBase58Check
      }"
    >
      <div
        [ngClass]="{ 'bg-danger': diamondDragCancel, show: diamondDragging }"
        class="diamond-mobile-drag-instructions"
      >
        <p class="d-block">
          {{
            !diamondDragMoved
              ? '<- Slide ->'
              : diamondDragCancel
              ? 'Release To Cancel'
              : 'Slide Down To Cancel - Release To Confirm'
          }}
        </p>
      </div>
    </div>
    <div
      class="feed-reaction cursor-pointer d-flex align-items-center"
      (click)="sendOneDiamond($event, false)"
      (mouseover)="addDiamondSelection($event)"
      (mouseleave)="removeDiamondSelection()"
    >
      <i
        class="feed-post-icon-row__icon mr-2"
        [ngClass]="{
          'icon-diamond': !sendingDiamonds,
          'fas fa-spinner fa-spin': sendingDiamonds,
          'fc-blue': postContent.PostEntryReaderState?.DiamondLevelBestowed > 0
        }"
        [ngStyle]="{
          visibility: diamondDragging ? 'hidden' : 'visible'
        }"
      ></i>
      <a
        [ngClass]="{
          'dragged-like': diamondDragging,
          'hide-diamonds':
            !globalVars.loggedInUser?.PublicKeyBase58Check ||
            postContent.ProfileEntryResponse?.PublicKeyBase58Check ===
              globalVars.loggedInUser?.PublicKeyBase58Check ||
            sendingDiamonds
        }"
        class="diamond-btn icon-diamond"
        id="diamond-button"
      >
        <div
          class="reaction-box"
          [ngStyle]="{
            height:
              !collapseDiamondInfo ||
              (diamondIdxDraggedTo === diamondCount && diamondDragLeftExplainer)
                ? '121px'
                : '55px'
          }"
        >
          <div
            *ngIf="
              !collapseDiamondInfo ||
              (diamondIdxDraggedTo === diamondCount && diamondDragLeftExplainer)
            "
          >
            <ng-container *ngTemplateOutlet="popTemplate"></ng-container>
          </div>
          <div
            *ngFor="let diamondIndex of diamondIndexes"
            [ngClass]="{
              show: diamondsVisible[diamondIndex],
              'dragged-icon': diamondIdxDraggedTo === diamondIndex
            }"
            class="reaction-icon transformable"
            (click)="onDiamondSelected($event, diamondIndex)"
            (mouseover)="diamondHovered = diamondIndex"
            (mouseleave)="diamondHovered = -1"
          >
            <label>{{ globalVars.getUSDForDiamond(diamondIndex + 1) }}</label>
            <i
              class="icon-diamond diamond-reaction"
              [ngStyle]="{
                color:
                  diamondIndex < getCurrentDiamondLevel() ||
                  diamondIndex <= this.diamondHovered ||
                  diamondIndex <= this.diamondIdxDraggedTo
                    ? 'var(--cblue)'
                    : 'var(--grey)'
              }"
            ></i>
          </div>
          <div
            class="reaction-icon show"
            (click)="toggleExplainer($event)"
            (mouseover)="collapseDiamondInfo = false"
            (mouseleave)="collapseDiamondInfo = true"
          >
            <i class="fas fa-info-circle diamond-reaction diamond-help"></i>
          </div>
        </div>
      </a>
      <!--Draggable element for mobile drag-selection-->
      <div
        (touchstart)="startDrag()"
        (touchend)="dragClick($event)"
        (cdkDragEnded)="endDrag($event)"
        (cdkDragMoved)="duringDrag($event)"
        class="diamond-mobile-drag-grab"
        [ngClass]="{
          'hide-diamonds':
            postContent.ProfileEntryResponse?.PublicKeyBase58Check ===
            globalVars.loggedInUser?.PublicKeyBase58Check
        }"
        id="diamond-mobile-drag-grab"
        cdkDrag
      ></div>
    </div>
    <span *ngIf="!hideNumbers">{{ postContent.DiamondCount }}</span>
  </div>

  <div class="d-none d-lg-flex cursor-pointer align-items-center">
    <i
      class="icon-link js-feed-post-icon-row__copy-post-link-icon feed-post-icon-row__icon"
      (click)="copyPostLinkToClipboard($event)"
    ></i>
    <span
      class="d-inline-block ml-1 cursor-pointer lh-12px fc-muted align-middle"
      matTooltipClass="global__mat-tooltip global__mat-tooltip-font-size"
      mat-raised-button
      #tooltip="matTooltip"
      [matTooltip]="
        globalVars.convertTstampToDateTime(postContent.TimestampNanos)
      "
      (auxclick)="onTimestampClickHandler($event)"
    >
      {{ globalVars.convertTstampToDaysOrHours(postContent.TimestampNanos) }}
    </span>
  </div>
</div>
